import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneralStoreService } from '../store/general.store';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private generalStoreService: GeneralStoreService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = this.generalStoreService.getUserValue();
    const token = this.generalStoreService.getTokenValue();
    const portalOwnerId = this.generalStoreService.getSelectedOwnerValue()?.id;
    const headers: any = {};

    if (token && !request.url.includes('Token')) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (request.url.includes('portal_user_logon_trace_start')) {
      headers.LogonTraceId = '0';
    } else if (user && user.logonTraceId) {
      headers.LogonTraceId = `${user.logonTraceId}`;
      request = request.clone({
        body: { ...request.body, portalOwnerId }
        // body: Object.assign(request.body, { portalOwnerId: ownerId })
      });
    }
    return next.handle(request.clone({ setHeaders: headers }));
  }
}
